import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import Modal from "antd/lib/modal/Modal";
import {
  professionalAction,
  userActions,
  spotservellienceAction,
} from "../../_actions";
import { saveAs } from "file-saver";
import {
  Drawer,
  Form,
  Select,
  Divider,
  PageHeader,
  Descriptions,
  message,
  Spin,
  DatePicker,
  Button,
  Row,
  Col,
} from "antd";
import { SpotForm } from "./SpotForm";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { PdfWithQrCode } from "./PdfWithQrCode";
import { ViewFormModel } from "./ViewForm/ViewFormModel";
import QRCode from "./QRCode";
import { roleAction } from "../../_actions/roleby.action";

const SpotServellienceTable = React.lazy(() =>
  import("./SpotServellienceTable").then((module) => ({
    default: module.SpotServellienceTable,
  }))
);

let columns = [];
let data = [];

// const baseUrl = 'http://localhost:8080/api';
class SpotServellience extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    loading: false,
    cctvLocationList: [],
    isCreateSpotDrawerVisible: false,
    resetFrom: false,
    progress: 0,
    setQRViewModel: false,
  };

  userForm = React.createRef();

  componentDidMount() {
    const { user } = this.props;
    this.props.dispatch(spotservellienceAction.getSpottype());
    this.props.dispatch(spotservellienceAction.getPatrollingPerson());
    if (user && user.cityId && user && user.role === "4") {
      this.setState({
        loading: true,
      });
      spotservellienceAction
        .getQrInformation(user && user.cityId)
        .then((res) => {
          res &&
            this.setState({
              cctvLocationList: res,
              loading: false,
            });
        });
    }

    if (user && user.cityId && user && user.role === "2") {
      this.setState({
        loading: true,
      });

      spotservellienceAction
        .getQrInformation(user && user.cityId)
        .then((res) => {
          let getQRTempList = _.filter(res, (o) => {
            return o.district == user.districtId;
          });
          res &&
            this.setState({
              cctvLocationList: getQRTempList,
              loading: false,
            });
        });
    }
    if ((user && user.role === "9") || user.role === "10") {
      let obj = {
        districtId: user.map_districtId,
      };
      this.setState({
        loading: true,
      });

      roleAction.getQrInformationByRole(obj).then((res) => {
        console.log("res", res);
        res.text().then(async (text) => {
          const tempData = text && JSON.parse(text);
          console.log("tempData", tempData);
          let tempFilterData = _.filter(
            tempData && _.flatten(tempData),
            function (o) {
              return Object.keys(o).length !== 0;
            }
          );
          this.setState({
            loading: false,
            cctvLocationList: tempFilterData,
          });
        });
      });
    }
  }

  getCityName = (id) => {
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };

  getSpotName = (id) => {
    const getSpottype = this.props && this.props.spotservellience.getSpottype;
    if (getSpottype && getSpottype.length) {
      return (
        _.filter(getSpottype, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(getSpottype, function (o) {
          return o.id === id;
        })[0].name
      );
    }
  };

  getFormat(date) {
    return moment(date).format("YYYY-MM-DD");
  }

  onOpenCreateSpotDrawer = () => {
    this.setState({
      isCreateSpotDrawerVisible: true,
      resetFrom: true,
      isUpdate: false,
    });
  };
  onCloseCreateSpotDrawer = () => {
    const { user } = this.props;
    if (user && user.cityId && user && user.role === "4") {
      this.setState({
        loading: true,
      });
      spotservellienceAction
        .getQrInformation(user && user.cityId)
        .then((res) => {
          res &&
            this.setState({
              cctvLocationList: res,
              loading: false,
            });
        });
    }

    if (user && user.cityId && user && user.role === "2") {
      this.setState({
        loading: true,
      });
      spotservellienceAction
        .getQrInformation(user && user.cityId)
        .then((res) => {
          let getQRTempList = _.filter(res, (o) => {
            return o.district == user.districtId;
          });
          res &&
            this.setState({
              cctvLocationList: getQRTempList,
              loading: false,
            });
        });
    }
    if ((user && user.role === "9") || user.role === "10") {
      let obj = {
        districtId: user.map_districtId,
      };
      this.setState({
        loading: true,
      });

      roleAction.getQrInformationByRole(obj).then((res) => {
        console.log("res", res);
        res.text().then(async (text) => {
          const tempData = text && JSON.parse(text);
          console.log("tempData", tempData);
          let tempFilterData = _.filter(
            tempData && _.flatten(tempData),
            function (o) {
              return Object.keys(o).length !== 0;
            }
          );
          this.setState({
            loading: false,
            cctvLocationList: tempFilterData,
          });
        });
      });
    }

    this.setState({
      isCreateSpotDrawerVisible: false,
      resetFrom: true,
      isUpdate: false,
    });
  };

  onSpotFormSave = () => {
    this.userForm.current.onFinish(true);
    // this.setState({
    //   isUpdate: true,
    // });
  };
  onSpotFormUpdate = () => {
    this.userForm.current.onFinish(false);
  };

  onCityChange = (cityId, form) => {
    if (cityId) {
      this.props.dispatch(professionalAction.getDistrict(cityId, form));
    }
  };

  onFormFinish = (values) => {
    const { user } = this.props;
    console.log("document", values);
    setTimeout(() => {
      const qrCodeElement = document.getElementById("react-qrcode-logo");
      if (qrCodeElement) {
        const qrCodeURL = qrCodeElement
          .toDataURL("image/png")
          .replace("image/png", "image/octet-stream");
        let obj = {
          qr_id: values.qr_id,
          qr_code: qrCodeURL,
          qr_name: values.spotName,
          landmark: values.landmark,
          is_geotagged: 0,
          spot_type_id: values.spotType,
          spotType: this.getSpotName(values.spotType),
          spot_time: values.spot_time,
          patrolling_person: values.patrolling_person,
          state: user && user.state,
          createdby: user && user.role,
          city: user && user.cityId,
          cityName: this.getCityName(user && user.cityId),
          district: values.district ? values.district : user && user.districtId,
          createdAt: new Date().toISOString({ timeZone: "+05:30" }),
          districtName: this.getDistrictName(
            values.district ? values.district : user && user.districtId
          ),
        };
        //console.log("obj+++++++++++", obj);
        // onSuccess("Ok");
        this.props.dispatch(spotservellienceAction.saveQrInformation(obj));
        this.setState((prevState) => ({
          isCreateUserDrawerVisible: false,
          resetFrom: true,
          isUpdate: true,
        }));
        message.success("Spot Type save Successfully!!!");
      } else {
        // Handle the case where the element is still not found
      }
    }, 100); // 100ms delay
  };

  onViewQrInformation = (data) => {
    if (data) {
      this.showQRViewModel();
      this.props.dispatch(spotservellienceAction.getQrInformationById(data));
    }
  };

  showQRViewModel = () => {
    this.setState({
      setQRViewModel: true,
    });
  };
  closeQRViewModel = () => {
    this.setState({
      setQRViewModel: false,
    });
  };

  getDistrictName = (id) => {
    const gunhaDistricts = this.props.basicDistricts;
    if (gunhaDistricts && gunhaDistricts.length) {
      return (
        _.filter(gunhaDistricts, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(gunhaDistricts, function (o) {
          return o.id === id;
        })[0].DistrictName
      );
    }
  };

  render() {
    const { user, loading, spotservellience } = this.props;
    const requiredKeys = [];
    if (this.state.cctvLocationList && this.state.cctvLocationList.length > 0) {
      let columns1 =
        this.state.cctvLocationList &&
        this.state.cctvLocationList.length &&
        this.state.cctvLocationList.map((itemObj, index) => {
          return {
            ...itemObj,
            key: index + 1,
            SrNo: index + 1,
          };
        });

      let tablelabes = columns1 && Object.keys(columns1[0]);

      let tableColumns = [];
      tablelabes.forEach((item) => {
        if (
          _.filter(requiredKeys, function (o) {
            return o === item;
          }).length
        ) {
          tableColumns.push(item);
        }
      });

      let columnList = tableColumns.map((item) => {
        return {
          title: item,
          dataIndex: item,
          key: item,
        };
      });
      // columns1.reverse();

      data = columns1;
      columns = columnList;
    } else {
      data = [];
    }
    return (
      <>
        <div className="col-md-6 col-md-offset-3">
          <div className="site-page-header-ghost-wrapper">
            <PageHeader
              ghost={false}
              onBack={false}
              title="Spot Servellience"
              extra={[
                <Button
                  type="primary"
                  className="mb-4"
                  onClick={this.onOpenCreateSpotDrawer}
                  style={{
                    display:
                      user.role === 4 || user.role === 2 ? "block" : "none",
                  }}
                >
                  Create Spot
                </Button>,
              ]}
            ></PageHeader>
          </div>

          <Divider />

          <div>
            <React.Suspense fallback={<div>Loading...</div>}>
              <SpotServellienceTable
                data={data}
                columns={columns}
                onViewQrInformation={this.onViewQrInformation}
                spotType={spotservellience.getSpottype}
              ></SpotServellienceTable>
            </React.Suspense>
          </div>

          <Drawer
            title="Create Spot"
            placement="right"
            width={720}
            closable={true}
            onClose={this.onCloseCreateSpotDrawer}
            visible={this.state.isCreateSpotDrawerVisible}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              >
                <Button
                  onClick={this.onCloseCreateSpotDrawer}
                  style={{ marginRight: 8 }}
                >
                  Cancel
                </Button>
                {!this.state.isUpdate ? (
                  <Button onClick={this.onSpotFormSave} type="primary">
                    Generate
                  </Button>
                ) : (
                  ""
                )}
              </div>
            }
          >
            <SpotForm
              ref={this.userForm}
              isUpdate={this.state.isUpdate}
              onFormFinish={this.onFormFinish}
              onFormUpdate={this.onFormUpdate}
              resetFrom={this.state.resetFrom}
              dataStates={this.props.professionals}
              onCityChange={this.onCityChange}
              user={user}
              spotType={spotservellience.getSpottype}
              patrollingPerson={spotservellience.patrollingPerson}
            ></SpotForm>
          </Drawer>

          <Modal
            title="QR Information"
            top
            visible={this.state.setQRViewModel}
            onOk={this.closeQRViewModel}
            onCancel={this.closeQRViewModel}
            width={95 + "%"}
          >
            <ViewFormModel
              dataStates={spotservellience}
              spotType={spotservellience.getSpottype}
            ></ViewFormModel>
          </Modal>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals, spotservellience } = state;
  const { user } = authentication;
  const { newsList, gpsInformationList, loading, basicDistricts } =
    professionals;
  return {
    user,
    users,
    newsList,
    professionals,
    spotservellience,
    loading,
    basicDistricts,
  };
}

const connectedSpotServellience = connect(mapStateToProps)(SpotServellience);
export { connectedSpotServellience as SpotServellience };
